let searchDesk = document.querySelector(".search-drop");
let searchBackDrop = document.querySelector(".search-backdrop");
let searchDeskBtn = document.querySelectorAll(".search-toggle");
let searchInput = document.querySelector(".search-box input");
let searchResultBox = document.querySelector(".searched-products");
let searchLoader = document.querySelector(".search-drop .loader-2");
////////////Search display
searchDeskBtn.forEach((el, ind) => {
  el.addEventListener("click", function () {
    searchDesk.classList.toggle("active");
    searchInput.textContent = "";
    searchResultBox.innerHTML = "";
    searchBackDrop.classList.toggle("active");
  });
});
// ///////////////////////Search queries
const searchProduct = (title) => {
  searchLoader.classList.add("active");
  fetch(
    window.Shopify.routes.root +
      `search/suggest?q=${title}&resources[type]=product&resources[options][fields]=title,product_type,variants.title&section_id=searched-products`
  )
    .then((response) => {
      requestResponse = response;
      return response.text();
    })
    .then((text) => {
      if (!requestResponse.ok) {
        throw new Error(`${requestResponse.status}: ${text}`);
      } else {
        let parser = new DOMParser();
        let html = parser.parseFromString(text, "text/html");
        let searchHtml = html.querySelector(
          "#predictive-search-results"
        );
        

        let productItems = searchHtml.querySelectorAll(".product-card"); 
        productItems.forEach(item => {
          let titleEl = item.querySelector(".card-title"); 
          if (titleEl && titleEl.textContent.trim().toLowerCase().startsWith("techno kids")) {
            item.remove();
          }
        });
        
        searchResultBox.innerHTML = "";
        searchResultBox.innerHTML = searchHtml.innerHTML;
        searchLoader.classList.remove("active");
        let viewAllBtn = document.querySelector(".view-all-search");
        viewAllBtn.setAttribute("href", `/search?q=${title}&type=product`);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};
const updateDeb = debounce((val) => {
  if (val.trim().length > 1) {
    searchProduct(val);
  } else {
    searchResultBox.innerHTML = "";
  }
});
function debounce(callback) {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, 1000);
  };
}
searchInput.addEventListener("input", function (e) {
  updateDeb(this.value);
});
